
import SearchZoomIn1 from "../../../assets/outline/SearchZoomIn1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SearchZoomIn1Icon({ className, dataTestid = "SearchZoomIn1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SearchZoomIn1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
